package one.healthium.onboarding.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import one.healthium.domain.common.TextStyle
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2

@Composable
fun HighlightItem(
    modifier: Modifier = Modifier,
    text: String,
    emoji: String,
    emojiHeight: Int,
    textStyle: TextStyle?,
    checkmarkTint: Color? = null,
) {
    Column(modifier) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 8.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            EmojiBox(
                modifier = Modifier.background(
                    color = gray_2,
                    shape = AppTheme.shapes.small,
                ),
                emojiHeight = emojiHeight,
                emoji = emoji,
            )
            Spacer(Modifier.width(16.dp))
            AppText(
                modifier = Modifier.weight(1f),
                text = text,
                style = textStyle.toTextStyle(AppTheme.textStyles.body2Medium),
            )
            Spacer(Modifier.width(12.dp))
            AppIcons.icCheckmark(checkmarkTint ?: AppTheme.colors.primary)
        }
        Box(
            modifier = Modifier
                .height(1.dp)
                .fillMaxWidth()
                .padding(start = (16 + emojiHeight).dp)
                .background(AppTheme.colors.divider)
        )
    }
}
